import { BlockComponent } from 'lib'
import { Stack } from 'components/layout/primitives'
import { SpaceProp } from 'components/layout/primitives/utils'
import { Split } from 'components/layout/primitives/Split'
import { CustomLabel } from 'components/inputs/common/fieldStyles'
import styled from '@emotion/styled'
import { colors } from 'parameters/ui'
import { ValueFormatter } from 'lib/numbers/format'
import { RangeInput, RangeInputProps } from '../RangeInput'

interface RangeFieldProps extends RangeInputProps {
	valueFormatter: ValueFormatter
	label: string
}

export const RangeField: BlockComponent<RangeFieldProps & SpaceProp> = ({
	label,
	name,
	options,
	onChange,
	value,
	valueFormatter,
	space
}) => {
	return (
		<Stack space={space}>
			<Split>
				<CustomLabel htmlFor={name}>{label}</CustomLabel>
				<p>{valueFormatter(value)}</p>
			</Split>
			<RangeInput options={options} name={name} value={value} onChange={onChange} />
			<Split>
				<AxisLabel>{valueFormatter(options.min)}</AxisLabel>
				<AxisLabel>{valueFormatter(options.max)}</AxisLabel>
			</Split>
		</Stack>
	)
}

const AxisLabel = styled.div`
	color: ${colors.secondaryDarkGrey1};
	font-size: 14px;
`
